import { render } from "./CreatorBanner.vue?vue&type=template&id=08047abc"
import script from "./CreatorBanner.vue?vue&type=script&lang=js"
export * from "./CreatorBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__